import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "section-header",
  style: {
    "position": "sticky"
  }
};
const _hoisted_2 = {
  class: "nav-bar-main"
};
const _hoisted_3 = {
  class: "nav-bar container d-flex justify-content-between align-items-center align-content-center"
};
const _hoisted_4 = ["href"];

const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/moblie/images/logo-2_2.png"
}, null, -1);

const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "nav-bar-open"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const _hoisted_10 = ["href"];
const _hoisted_11 = ["href"];
const _hoisted_12 = ["href"];
const _hoisted_13 = ["href"];
const _hoisted_14 = ["href"];
const _hoisted_15 = {
  class: "item-list"
};
const _hoisted_16 = {
  class: "item"
};
const _hoisted_17 = {
  class: "item"
};
const _hoisted_18 = {
  class: "item"
};
const _hoisted_19 = {
  class: "item"
};
const _hoisted_20 = {
  class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_cell = _resolveComponent("van-cell");

  const _component_van_collapse_item = _resolveComponent("van-collapse-item");

  const _component_van_collapse = _resolveComponent("van-collapse");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [!$data.isnavopne ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 0,
    onClick: _cache[0] || (_cache[0] = $event => $data.isnavopne = true),
    size: "22",
    name: "/moblie/images/navOpen-icon.png"
  })) : _createCommentVNode("", true), $data.isnavopne ? (_openBlock(), _createBlock(_component_van_icon, {
    key: 1,
    onClick: _cache[1] || (_cache[1] = $event => $data.isnavopne = false),
    size: "22",
    name: "/moblie/images/navClose-icon.png"
  })) : _createCommentVNode("", true), _createElementVNode("a", {
    href: $data.shopUrl + '/mobileview/index.html'
  }, _hoisted_6, 8, _hoisted_4), _createElementVNode("div", null, [_createVNode(_component_van_icon, {
    size: "22",
    class: "user-icon",
    onClick: $options.openDown,
    name: "/moblie/images/user-icon.png"
  }, null, 8, ["onClick"]), _createVNode(_component_van_icon, {
    onClick: $options.clickToCart,
    class: "cart-icon",
    size: "22",
    name: "/moblie/images/cart-icon.png",
    badge: _ctx.shopping_cart_num || ''
  }, null, 8, ["onClick", "badge"])])]), _createElementVNode("div", {
    class: _normalizeClass(["nav-barmain-open", $data.isnavopne ? 'nav-bar-open-ok' : ''])
  }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_collapse, {
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.activeNames = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("a", {
      href: $data.shopUrl + '/mobileview/index.html'
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('home')
    }, null, 8, ["value"])], 8, _hoisted_8), _createElementVNode("a", {
      href: $data.shopUrl + '/mobileview/shopping.html'
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('shopping')
    }, null, 8, ["value"])], 8, _hoisted_9), _createElementVNode("a", {
      href: $data.shopUrl + '/mobileview/collocation.html'
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('collocation')
    }, null, 8, ["value"])], 8, _hoisted_10), _createVNode(_component_van_collapse_item, {
      "is-link": false,
      disabled: "",
      title: _ctx._t('download'),
      name: "2"
    }, {
      default: _withCtx(() => [_createElementVNode("a", {
        href: $data.shopUrl + '/mobileview/simapppro.html'
      }, [_createVNode(_component_van_cell, {
        value: "Simapp Pro"
      })], 8, _hoisted_11), _createElementVNode("a", {
        href: $data.shopUrl + '/mobileview/regular.html'
      }, [_createVNode(_component_van_cell, {
        value: _ctx._t('regular')
      }, null, 8, ["value"])], 8, _hoisted_12)]),
      _: 1
    }, 8, ["title"]), _createElementVNode("a", {
      href: _ctx.navText.help
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('help')
    }, null, 8, ["value"])], 8, _hoisted_13), _createElementVNode("a", {
      href: $data.shopUrl + '/mobileview/contact.html'
    }, [_createVNode(_component_van_cell, {
      value: _ctx._t('contact')
    }, null, 8, ["value"])], 8, _hoisted_14)]),
    _: 1
  }, 8, ["modelValue"])])], 2), $data.isusernav ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: {
      "position": "fixed",
      "left": "0",
      "right": "0",
      "top": "0",
      "bottom": "0",
      "opacity": "0"
    },
    onClick: _cache[3] || (_cache[3] = $event => $data.isusernav = false),
    onTouchmove: _cache[4] || (_cache[4] = $event => $data.isusernav = false),
    onWheel: _cache[5] || (_cache[5] = $event => $data.isusernav = false)
  }, null, 32)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["drop-down", $data.isusernav ? 'open-drop-down' : '']),
    style: {
      "z-index": "10!important"
    }
  }, [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_16, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = (...args) => $options.clickLogin && $options.clickLogin(...args))
  }, _toDisplayString(_ctx._t('logIn')), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("a", {
    onClick: _cache[7] || (_cache[7] = (...args) => $options.clickRegister && $options.clickRegister(...args))
  }, _toDisplayString(_ctx._t('signUp')), 1)])], 512), [[_vShow, !$options.islogin]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [_createElementVNode("a", {
    onClick: _cache[8] || (_cache[8] = (...args) => $options.clickToMy && $options.clickToMy(...args))
  }, _toDisplayString(_ctx._t('userCenter')), 1)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("a", {
    onClick: _cache[9] || (_cache[9] = (...args) => $options.clickToMyOrder && $options.clickToMyOrder(...args))
  }, _toDisplayString(_ctx._t('myOrder')), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("a", {
    onClick: _cache[10] || (_cache[10] = (...args) => $options.clickLogout && $options.clickLogout(...args))
  }, _toDisplayString(_ctx._t('logOut')), 1)])], 512), [[_vShow, $options.islogin]])])], 2)])]);
}